import {
	TableTemplateButtons,
	TableTemplateButtonsEvent,
} from "../components/table/table-template.model";
import { Document, IDocument } from "../entities/document.model";
import { Formatter } from "../../services/formatter/formatter.service";

export interface IParticipantDocumentRow {
	id: number | null;
	participantId: number;
	documentName: string; // name + file size
	uploadedOn: string; // ISO date string
	notes: string | null;
	actionsTemplate: TableTemplateButtons;
	entity: IDocument;
}

export class ParticipantDocumentRow implements IParticipantDocumentRow {
	id: number | null;
	participantId: number;
	documentName: string;
	uploadedOn: string;
	notes: string | null;
	actionsTemplate: TableTemplateButtons;
	entity: Document;
	fileTypeIsViewable: boolean;

	constructor(
		params: IDocument,
		viewOrDownloadFn: (e: TableTemplateButtonsEvent) => void,
		editFn: (e: TableTemplateButtonsEvent) => void,
		deleteFn: (e: TableTemplateButtonsEvent) => void
	) {
		this.id = params.id ?? null;
		this.participantId = params.participantId;
		// Show name with file size if available, otherwise just the name
		this.documentName = params.fileSize
			? `${params.name} ${Formatter.formatFileSize(params.fileSize)}`
			: params.name;
		this.uploadedOn = params.uploadedOn;
		this.notes = params.notes || null;
		this.actionsTemplate = this.setActionsTemplate(params, viewOrDownloadFn, editFn, deleteFn);
		this.entity = new Document(params);
		this.fileTypeIsViewable = this.setFileTypeIsViewable(params);
	}

	private setFileTypeIsViewable = (params: IDocument): boolean => {
		const fileType = params.s3Url?.split(".").pop();
		return (
			fileType === "pdf" ||
			fileType === "jpg" ||
			fileType === "jpeg" ||
			fileType === "png" ||
			fileType === "gif" ||
			fileType === "bmp" ||
			fileType === "tiff" ||
			fileType === "ico" ||
			fileType === "webp"
		);
	};

	private setActionsTemplate = (
		params: IDocument,
		viewOrDownloadFn: (e: TableTemplateButtonsEvent) => void,
		editFn: (e: TableTemplateButtonsEvent) => void,
		deleteFn: (e: TableTemplateButtonsEvent) => void
	): TableTemplateButtons => [
		{
			id: "viewAction",
			label: this.setFileTypeIsViewable(params)
				? "PARTICIPANT.DOCUMENTS.BUTTON_VIEW"
				: "PARTICIPANT.DOCUMENTS.BUTTON_DOWNLOAD",
			className: "p-button-sm p-button-rounded participant-documents-view-download-btn",
			disabled: false,
			onClick: viewOrDownloadFn,
		},
		{
			id: "editAction",
			className: "p-button-text neutral",
			icon: "pi pi-pencil",
			disabled: false,
			onClick: editFn,
		},
		{
			id: "deleteAction",
			className: "p-button-text neutral",
			icon: "pi pi-trash",
			disabled: false,
			onClick: deleteFn,
		},
	];
}
